import { AxiosError, AxiosResponse } from "axios"
import { useInfiniteQuery, UseInfiniteQueryResult, useQuery } from "react-query"

import axiosInstance from "../../api"
import { Endpoint } from "../../enpoints.types"
import {
  HrArgs,
  HrStudentsShortArgs,
  HrStudentsShortResponse,
  HrTypes,
} from "./hr.types"

export const useInfiniteQueryHrClass = (
  args?: HrArgs
): UseInfiniteQueryResult<AxiosResponse<HrTypes>, AxiosError> => {
  return useInfiniteQuery<AxiosResponse<HrTypes>, AxiosError>(
    ["hrClass", args?.classId],
    async ({ pageParam = 0 }) => {
      return axiosInstance(
        Endpoint.CLASSES_ID_HELPER_HR_STUDENTS.replace(
          "ID",
          `${args?.classId}`
        ),
        {
          params: {
            filter: args?.filter,
            skip: pageParam,
            limit: args?.limit,
            sort_by: args?.sort_by,
            sorting: args?.sorting,
          },
        }
      )
    },
    {
      ...args?.options,
      getNextPageParam: (lastPage, allPages) => {
        const loadedItemCount = allPages.reduce(
          (acc, page) => acc + page.data.objects.length,
          0
        )
        const totalItems = lastPage.data.all_objects_count

        if (loadedItemCount < totalItems) {
          return loadedItemCount
        }
        return undefined
      },
    }
  )
}

export const useQueryHrStudentsShort = (args: HrStudentsShortArgs) => {
  return useQuery<AxiosResponse<HrStudentsShortResponse>, AxiosError>(
    ["hrStudentsShort", args.classId, args.filter, args.sorting, args.sort_by],
    async () => {
      return axiosInstance(
        Endpoint.CLASSES_ID_HELPER_HR_STUDENTS_SHORT.replace(
          "ID",
          `${args.classId}`
        ),
        {
          params: {
            filter: args.filter,
            sort_by: args.sort_by,
            sorting: args.sorting,
          },
        }
      )
    },
    {
      ...args.options,
    }
  )
}
